import { useState as u, useEffect as r } from "react";
function l(...t) {
  const [s, n] = u(!1);
  return r(() => {
    function o(c) {
      const i = c.target;
      t.some((e) => e == null ? void 0 : e.contains(i)) || n(!1);
    }
    return document.body.addEventListener("click", o, !0), () => {
      document.body.removeEventListener("click", o, !0);
    };
  }, [t]), {
    isOpen: s,
    setIsOpen: n
  };
}
export {
  l as useCloseOnClickOutside
};
//# sourceMappingURL=useCloseOnClickOutside.js.map
